export default "__VITE_ASSET__DvwzLw1e__"